module.exports = __webpack_public_path__ + "img/nuxt.ebc840eb.svg";